import { notification } from 'antd';

export const zeroLeft = (n: number): string => Math.floor(n).toString().padStart(2, '0');

export function secondsToHouers(seconds: number): string {
  const hours = zeroLeft(seconds / 3600);
  const min = zeroLeft((seconds / 60) % 60);
  const sec = zeroLeft((seconds % 60) % 60);
  return `${hours}h : ${min}m : ${sec}s`;
}

export function houersAndMinutes(seconds: number): string {
  const hours = zeroLeft(seconds / 3600);
  const min = zeroLeft((seconds / 60) % 60);
  return `${hours}h : ${min}m`;
}

export function secondsToMinutes(seconds: number): string {
  const min = zeroLeft((seconds / 60) % 60);
  const sec = zeroLeft((seconds % 60) % 60);
  return `${min}:${sec}`;
}

export const openNotification = (title: string, icon: any, description?: string): void => {
  notification.open({
    message: title,
    icon: icon,
    description: description,
    placement: 'bottomRight',
  });
};

export const colorIconConversation = (urgencia: string): string => {
  let colorIcon: string;
  switch (urgencia) {
    case 'URGENTE':
      colorIcon = '#F5222D';
      break;

    case 'ALTA':
      colorIcon = '#FA8C16';
      break;

    case 'MEDIA':
      colorIcon = '#52C41A';
      break;

    case 'BAIXA':
      colorIcon = '#939195';
      break;

    default:
      colorIcon = '#188fff';
      break;
  }
  return colorIcon;
};

export const colorBackground = (urgencia: string): string => {
  let colorIcon: string;
  switch (urgencia) {
    case 'URGENTE':
      colorIcon = 'rgba(245, 34, 45, 0.1)';
      break;

    case 'ALTA':
      colorIcon = 'rgba(250, 140, 22, 0.1)';
      break;

    case 'MEDIA':
      colorIcon = 'rgba(83, 196, 26, 0.1)';
      break;

    case 'BAIXA':
      colorIcon = 'rgba(147, 145, 149, 0.1)';
      break;

    default:
      colorIcon = '#f0f2f5';
      break;
  }
  return colorIcon;
};
